<template>
    <div class="add_account_mask"  v-if="addOk">
    <el-card class="add_account">
        <div slot="header" class="clearfix">
            <span v-show="userType == 0 || userType == 1 || userType == 2" style="line-height: 36px;">新增账号</span>
        </div>
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="fromAddAccount" ref="fromAddAccount">
            <el-form-item label="登录账号" prop="user_name">
                <el-input v-model="fromAddAccount.user_name" placeholder="请输入登录手机号"></el-input>
            </el-form-item>
            <el-form-item label="账号类型">
                <el-select style="width:100%;" v-model="fromAddAccount.user_type" placeholder="请选择账号类型">
                    <el-option v-show="userType == 0 || userType == 1" label="代理商" value="1"></el-option>
                    <el-option v-show="userType == 0 || userType == 1 || userType == 2" label="设备主" value="2"></el-option>
                    <el-option label="维护人员" value="3"></el-option>
                    <el-option label="商户" value="4"></el-option>
                    <el-option label="销售" value="5" v-show="userType == 0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提现权限" v-if="fromAddAccount.user_type == 1">
              <el-radio-group v-model="withdrawType">
                <el-radio label="有提现权"></el-radio>
                <el-radio label="无提现权"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="登录密码"  prop="password">
                <el-input type="password" v-model="fromAddAccount.password" placeholder="请输入登录密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码"  prop="pwdAgain">
                <el-input type="password" v-model="fromAddAccount.pwdAgain" placeholder="请确认登录密码"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名"  prop="nickName">
                <el-input v-model="fromAddAccount.nickName" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button style="width:40%;" @click="resetForm('fromAddAccount')">重置</el-button>
                <el-button style="width:40%" type="primary" @click="submitForm('fromAddAccount')" :loading="loading">提交</el-button>
            </el-form-item>
        </el-form>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import md5 from 'js-md5'
    export default {
      props: ['addShow'],
      data () {
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'))
          } else if (value !== this.fromAddAccount.password) {
            callback(new Error('两次输入密码不一致!'))
          } else {
            callback()
          }
        }
        var validatePhone = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入手机号'))
          } else {
            var phoneReg = /^[1][34578]\d{9}$/
            if (!phoneReg.test(value)) {
              callback(new Error('手机号格式不正确，请重新输入'))
            } else {
              callback()
            }
          }
        }
        return {
          withdrawType: false,
          labelPosition: 'right',
          loading: false,
          fromAddAccount: {
            user_name: '',
            user_type: '3',
            password: '',
            pwdAgain: '',
            nickName: ''
          },
          userType: this.$store.state.userType,
          rules: {
            user_name: [
              {validator: validatePhone, trigger: 'blur'}
            ],
            password: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              { min: 6, max: 12, message: '密码长度在 6 到 12 个字符', trigger: 'blur' }
            ],
            pwdAgain: [
              {validator: validatePass2, trigger: 'blur'}
            ],
            nickName: [
              {required: true, message: '请输入用户名', trigger: 'blur'},
              { min: 2, max: 8, message: '用户名长度在 2 到 8 个字符', trigger: 'blur' }
            ]
          }
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        }
      },
      methods: {
        boxColose () {
          this.$emit('closeAddAccount', false)
        },
        submitForm (formData) {
          this.$refs.fromAddAccount.validate((valid) => {
            if (valid) {
              this.loading = true
              var _this = this
              var withdrawType = this.fromAddAccount.user_type === '1' ? (this.withdrawType === '有提现权' ? 1 : 0) : 0
              if (this.fromAddAccount.user_type === '2') {
                withdrawType = 1
              }
              var params = {
                user_name: this.fromAddAccount.user_name,
                password: md5(this.fromAddAccount.password),
                nickName: this.fromAddAccount.nickName,
                user_type: this.fromAddAccount.user_type,
                is_balance: withdrawType
              }
              var url = '/custom/register'
              $axios.post(url, params, 'headers', function (res) {
                _this.loading = false
                if (res.resultStatus) {
                  _this.$message({
                    message: '新账号创建成功！',
                    type: 'success'
                  })
                  _this.resetForm()
                  _this.$emit('closeAddAccount', false)
                } else {
                  _this.$message({
                    message: '账号创建失败！' + res.errorMessage,
                    type: 'error'
                  })
                }
              }, function (err) {
                _this.loading = false
                _this.$message({
                  type: 'error',
                  duration: 1000 * 5,
                  message: '服务器异常，请稍后再试!' + err
                })
              })
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '请检查填写的数据!'
              })
              return false
            }
          })
        },
        resetForm (formData) {
          this.$refs.fromAddAccount.resetFields()
        }

      }
    }
</script>
<style lang="scss">
  .add_account_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
  .add_account {
    width: 400px;
    top: 20%;
    left: 50%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
      padding: 10px
    }
    .el-card__body {
        padding: 20px 40px;
        .el-form-item {
            width: 90%
        }
    }
  }
  }
</style>



// WEBPACK FOOTER //
// src/page/accountMgr/addAccount.vue